import TagManager from 'react-gtm-module'
import QuestEvent from '../../constants/events'

export const gtmUploadExperiencePolicyAction = (
  experienceId,
  fileName,
  fileType,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: QuestEvent.event.uploadQuestPolicy,
      eventProps: {
        category: QuestEvent.category.uploadQuestPolicyCategory,
        action: 'User upload experience policy document',
        label: 'Upload experience policy document',
        value: `User upload experience policy document (experienceId - ${experienceId}, fileName - ${fileName}, fileType - ${fileType})`,

        userId,
      },
    },
  })
}

export const gtmUploadExperienceHeadshotAction = (
  experienceId,
  fileName,
  fileType,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: QuestEvent.event.uploadQuestHeadshot,
      eventProps: {
        category: QuestEvent.category.uploadQuestHeadshotCategory,
        action: 'User upload experience headshot document',
        label: 'Upload experience headshot document',
        value: `User upload experience headshot document (experienceId - ${experienceId}, fileName - ${fileName}, fileType - ${fileType})`,

        userId,
      },
    },
  })
}

export const gtmUploadExperiencePassportAction = (
  experienceId,
  fileName,
  fileType,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: QuestEvent.event.uploadQuestPassport,
      eventProps: {
        category: QuestEvent.category.uploadQuestPassportCategory,
        action: 'User upload experience passport document',
        label: 'Upload experience passport document',
        value: `User upload experience passport document (experienceId - ${experienceId}, fileName - ${fileName}, fileType - ${fileType})`,

        userId,
      },
    },
  })
}

export const gtmUploadExperienceTicketAction = (
  experienceId,
  fileName,
  fileType,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: QuestEvent.event.uploadQuestTicket,
      eventProps: {
        category: QuestEvent.category.uploadQuestTicketCategory,
        action: 'User upload experience ticket document',
        label: 'Upload experience ticket document',
        value: `User upload experience ticket document (experienceId - ${experienceId}, fileName - ${fileName}, fileType - ${fileType})`,

        userId,
      },
    },
  })
}

export const gtmStartExperienceEnrollmentAction = (
  experienceId,
  experienceCustomFormId,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: QuestEvent.event.startQuestEnrollment,
      eventProps: {
        category: QuestEvent.category.startQuestEnrollmentCategory,
        action: 'User start experience enrollment process',
        label: 'Start experience enrollment process',
        value: `User start experience enrollment process (experienceId - ${experienceId}, formId - ${experienceCustomFormId})`,

        userId,
      },
    },
  })
}

export const gtmViewExperienceEnrollmentResponsesAction = (
  experienceId,
  experienceCustomFormId,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: QuestEvent.event.viewQuestEnrollmentResponses,
      eventProps: {
        category: QuestEvent.category.viewQuestEnrollmentResponsesCategory,
        action: 'User view experience enrollment responses',
        label: 'View experience enrollment responses',
        value: `User view experience enrollment responses (experienceId - ${experienceId}, formId - ${experienceCustomFormId})`,

        userId,
      },
    },
  })
}

export const gtmSubmitExperienceEnrollmentAction = (
  experienceId,
  experienceCustomFormId,
  answersCount,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: QuestEvent.event.submitQuestEnrollment,
      eventProps: {
        category: QuestEvent.category.submitQuestEnrollmentCategory,
        action: 'User submit experience enrollment form',
        label: 'Submit experience enrollment form',
        value: `User submit experience enrollment form (experienceId - ${experienceId}, formId - ${experienceCustomFormId}, answersCount - ${answersCount})`,

        userId,
      },
    },
  })
}
